import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import { ACTIVE_LANGUAGES } from '@olimhub/shared'
import type { CategoryAppliesTo, ActiveLanguage, Category } from '@olimhub/shared'
import { categoriesApi } from '@/api'

export function resolveActiveLanguage(lang: string): ActiveLanguage {
  const code = lang.slice(0, 2)
  return (ACTIVE_LANGUAGES as readonly string[]).includes(code) ? (code as ActiveLanguage) : 'en'
}

// Admin-curated category picker options for Event/Bazaar/Help/Action/Group
// creation and edit forms (see LESSONS_LEARNED.md — Admin Hub + Categories).
export function useCategoryOptions(type: CategoryAppliesTo, enabled = true): {
  options: Category[]
  language: ActiveLanguage
  isLoading: boolean
} {
  const { i18n } = useTranslation()
  const language = resolveActiveLanguage(i18n.language)
  const { data, isLoading } = useQuery({
    queryKey: ['categories', type, language],
    queryFn: () => categoriesApi.getForType(type, language),
    enabled,
  })
  return { options: data ?? [], language, isLoading }
}
